/**
 * Baggage keys sent on every request as W3C baggage. Privacy allowlist: adding a member is a
 * privacy decision. Values are literal wire keys; keyset is the emit list.
 */
export enum BaggageKeys {
  PageId = 'ui_page_id',
  UserId = 'ui_user_id',
  FirmId = 'ui_firm_id',
  FileId = 'ui_file_id',
  RumSessionOrg = 'ui_rum_session_org',
  RumSessionId = 'ui_rum_session_id',
  RumSessionTs = 'ui_rum_session_ts',
}

/**
 * Keys a provider may write via `useTelemetry`. RumSession* are excluded because they are
 * resolved per-request by fullStorySession, not stored.
 */
export type SettableBaggageKey = Exclude<
  BaggageKeys,
  BaggageKeys.RumSessionOrg | BaggageKeys.RumSessionId | BaggageKeys.RumSessionTs
>;

/** Any baggage value. Stringified on the way in, so numbers are allowed for numeric ids. */
export type BaggageValue = string | number | null | undefined;

/**
 * Sanitize baggage values: undefined, null, '', and the literal strings 'undefined'/'null'
 * all collapse to undefined so a key is omitted rather than emitted with a meaningless value.
 */
export function normalizeBaggageValue(value: BaggageValue): string | undefined {
  if (value === undefined || value === null) return undefined;
  const str = String(value);
  if (str === '' || str === 'undefined' || str === 'null') return undefined;
  return str;
}
